// "Calculate IOL" beside the lens type selector on the surgical plan. Once the eye has biometry -
// loaded off a scan or typed in - this hands the measurements for the planned operation to the
// external IOL calculator and opens it in a new tab. On a both-eyes plan either button sends both
// eyes. See services/BiomAPIService.js for what is sent.
app.component("preOpIolCalculator", {
	templateUrl: "app/src/js/components/preOp/preOpPlan/preOpIolCalculator/preOpIolCalculator.html",
	controller: "preOpIolCalculatorController",
	bindings: {
		eyeTitle: "@",
	},
});

app.controller("preOpIolCalculatorController", [
	"$scope",
	"$window",
	"PreOp",
	"CurrentPatient",
	"BiomAPIService",
	function ($scope, $window, PreOp, CurrentPatient, BiomAPIService) {
		$scope.isSending = false;
		$scope.errorMessage = null;

		// Null rather than a default eye: eyeTitle arrives through an interpolated "@" binding, and
		// guessing during the digest that fills it would offer one eye's button over the other's data.
		function eyeKey() {
			if ($scope.$ctrl.eyeTitle === "OD") return "od";
			if ($scope.$ctrl.eyeTitle === "OS") return "os";
			return null;
		}

		function biometry(eye) {
			const plan = PreOp.data && PreOp.data.surgical_plan_section;
			return (eye && plan && plan.biometry && plan.biometry[eye]) || null;
		}

		function lensStatus(eye) {
			const vision = PreOp.data && PreOp.data.vision_section;
			const status = eye && vision && vision.lens_status && vision.lens_status[eye];
			return status && status.status;
		}

		// The eye's record on the scan the workup was loaded from, which still holds the CCT, LT and
		// WTW that the workup's own biometry has nowhere to store.
		function importedEye(eye) {
			return (eye && PreOp.biometryImport && PreOp.biometryImport[eye]) || null;
		}

		function isBothEyes() {
			const plan = PreOp.data && PreOp.data.surgical_plan_section;
			const intraocular = plan && plan.surgical_plan_intraocular;
			return !!intraocular && intraocular.operative_eye === "BOTH";
		}

		// The sides this button hands over. On a both-eyes plan that is every eye with usable biometry,
		// whichever of the two buttons was pressed - the calculator works both eyes at once, and a
		// surgeon planning both should not have to run it twice and merge the answers by hand. On a
		// one-eye plan only the operative eye is sent, so the fellow eye's measurements never leave
		// CatTrax for a calculation that has no use for them.
		function eyesToSend() {
			const sides = isBothEyes() ? ["od", "os"] : [eyeKey()];
			return sides.reduce(function (eyes, eye) {
				if (eye && BiomAPIService.hasCalculableBiometry(biometry(eye))) {
					eyes[eye] = {
						biometry: biometry(eye),
						imported: importedEye(eye),
						lensStatus: lensStatus(eye),
					};
				}
				return eyes;
			}, {});
		}

		// Always offered, whether or not biometry has been entered yet - opening the calculator empty
		// is a reasonable thing to want, and the surgeon can type into it. Only a missing calculator
		// address hides the button, because then there is nowhere for it to go.
		$scope.canOpen = function () {
			return BiomAPIService.isConfigured();
		};

		$scope.openCalculator = function () {
			if ($scope.isSending || !$scope.canOpen()) {
				return;
			}
			$scope.isSending = true;
			$scope.errorMessage = null;

			// Opened now, while we are still inside the click, because a popup blocker will not let a
			// window through once the BiomAPI round trip has finished. It is pointed at the calculator
			// when the link comes back, and closed if it never does.
			const tab = $window.open("", "_blank");

			const patient = (CurrentPatient && CurrentPatient.patient) || {};
			BiomAPIService.buildCalculatorLink(eyesToSend(), {
				deviceType: PreOp.biometryDevice,
				initials: BiomAPIService.initials(patient.firstName, patient.lastName),
				patientId: BiomAPIService.patientId(patient.nhi, patient.medicare_details),
				gender: patient.gender,
			})
				.then(function (url) {
					if (tab) {
						tab.location = url;
					} else {
						// Blocked anyway - send this tab instead rather than losing the calculation.
						$window.location.href = url;
					}
				})
				.catch(function (rejection) {
					if (tab) {
						tab.close();
					}
					$scope.errorMessage = BiomAPIService.failureMessage(rejection);
				})
				.finally(function () {
					$scope.isSending = false;
				});
		};
	},
]);
